import React from 'react';
import { Button } from 'antd';
import { usePermissions } from '../../hooks/usePermissions';
import { ActionType } from 'components';

/**
 * PermissionButton:
 * - Renders button only if user can view the module
 * - Enables button based on `type` permission
 * 
 * @param {Object} props
 * @param {string} props.module Module name
 * @param {'create' | 'edit' | 'view' | 'delete'} props.type Type of button action
 * @param {any} props.rest Additional button props
 */
const PermissionButton = ({
  module,
  buttonType = ActionType.VIEW,
  ...rest
}) => {
  const { canViewModule, can } = usePermissions();

  // Hide the button entirely if user can't view the module
  if (!canViewModule(module)) return null;

  // Determine whether the user has the required permission
  const isEnabled = can(module, buttonType) && !rest.disabled;

  return <Button {...rest} disabled={!isEnabled} />;
};

export default PermissionButton;
